const apis = {
    apiTip: '創建 API key 滿足您的交易需求。為保障資產安全，請不要洩露您的 API key。',
    cjapi: '創建API',
    bzm: '備註名',
    qx: '權限',
    cjrq: '創建日期',
    cz: '操作',
    ck: '查看',
    bj: '編輯',
    sc: '刪除',
    mm: '密碼 (Passphrase)',
    qsrmm: '請輸入密碼 (Passphrase)',
    sjyzm: '手機驗證碼',
    qsryzm: '請輸入驗證碼',
    yxyzm: '郵箱驗證碼',
    dzbmd: 'IP 地址白名單 (可選)',
    my: '秘鑰',
    cancel: '取 消',
    confirm: '確 定',
    fzapi: '複製API信息',
    qdsc: '要刪除 {name} API 嗎？',
    tip: '提示',
    sccg: '刪除成功!',
    yqxsc: '已取消刪除',
    tips: '註：',
    zdcy: '每個主帳戶和子帳戶最多可持有 50 個活躍 API key。',
    qwxl: '請不要洩漏您的 API key；為 API key 綁定 IP 可以有效提高安全性。',
    dsfbd: '將擁有交易和提幣權限的 API 與第三方平台綁定，可能會導致 API 信息洩露，請謹慎操作。',
    zdsc: '為了您的資金安全，未綁定 IP 地址且擁有交易或提幣權限的 API key，將在閒置 14 天之後自動刪除，需重新申請。已綁定 IP 或僅擁有讀取權限的 API key 無有效期限制。',
    dq: '讀取',
    jy: '交易',
    ljcj: '立即創建',
    qsrbzm: '請輸入備註名',
    cjcg: '創建成功',
    czapi: '重置API',
    cjlc: '點擊創建 API key > 創建屬於自己的 API key 等信息 > 查看 API 文檔詳情 > 進行開發交易',
    zdbddz: '每個 API key 最多綁定 20 個 IP 地址，添加多個 IP 地址請用半角逗號分隔。',
    xgcg: '修改成功',
  }
  
export {
    apis
  }


// WEBPACK FOOTER //
// ./src/i18n/lang/api/tw.js